"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchFunction = getFetchFunction;
exports.fetchInitialFiles = fetchInitialFiles;
exports.fetchMoreFiles = fetchMoreFiles;
exports.setPanel = setPanel;
exports.searchFiles = searchFiles;
exports.goBack = goBack;
exports.setSearchQuery = setSearchQuery;
exports.selectFile = selectFile;
exports.deselectFile = deselectFile;
exports.maybeFetchFolders = maybeFetchFolders;
exports.trackInteraction = trackInteraction;
exports.updateDetailHeight = updateDetailHeight;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = _interopRequireDefault(require("immutable"));

var _Constants = require("FileManagerCore/Constants");

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var FilesApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

var _Files2 = require("FileManagerCore/actions/Files");

var _Folders = require("FileManagerCore/actions/Folders");

var _Constants2 = require("FileManagerLib/Constants");

var _ActionTypes2 = require("FileManagerLib/actions/ActionTypes");

var _utils = require("FileManagerLib/utils/utils");

var DEFAULT_QUERY = _immutable.default.Map({
  order_by: '-updated'
});

function getFilesQuery() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = DEFAULT_QUERY.merge(options);

  switch (query.get('type')) {
    case _Constants2.DrawerTypes.IMAGE:
      return query.set('type', _Constants.FileTypes.IMG);

    case _Constants2.DrawerTypes.VIDEO:
    case _Constants2.DrawerTypes.HUBL_VIDEO:
      return query.set('type', _Constants.FileTypes.MOVIE);

    case _Constants2.DrawerTypes.DOCUMENT:
      return query.set('type', _Constants.FileTypes.DOCUMENT);

    case _Constants2.DrawerTypes.FILE:
    default:
      return query.delete('type');
  }
}

function getFetchFunction(drawerType) {
  if (drawerType === _Constants2.DrawerTypes.HUBL_VIDEO) {
    return FilesApi.fetchIntegratedVideos;
  }

  return FilesApi.fetchFiles;
}

function fetchInitialFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var drawerType = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState, httpClient) {
    var query = getFilesQuery(options);
    var fetchFunction = getFetchFunction(drawerType);
    dispatch((0, _Files2.attemptFilesFetch)(query));
    fetchFunction(query, httpClient).then(function (data) {
      dispatch((0, _Files2.receiveFilesFetch)(query, data));
    }, function (error) {
      dispatch((0, _Files2.failFilesFetch)(query, error));
    }).done();
  };
}

function fetchMoreFiles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var drawerType = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState, httpClient) {
    var fetchFunction = getFetchFunction(drawerType);
    var query = getFilesQuery(options);
    dispatch({
      type: _ActionTypes.FETCH_MORE_FILES_ATTEMPTED,
      query: query
    });
    fetchFunction(query, httpClient).then(function (data) {
      dispatch({
        type: _ActionTypes.FETCH_MORE_FILES_SUCCEEDED,
        query: query,
        data: data
      });
    }).done();
  };
}

function setPanel(_ref) {
  var activePanel = _ref.activePanel,
      selectedFolder = _ref.selectedFolder,
      searchQuery = _ref.searchQuery;
  return {
    type: _ActionTypes2.SET_PANEL,
    activePanel: activePanel,
    selectedFolder: selectedFolder,
    searchQuery: searchQuery,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      usageTrackerJsName: 'fileManagerSetPanelExploreFiles',
      action: 'set-panel',
      meta: {
        panel: _Constants2.TrackingPanelLabels[activePanel]
      }
    })
  };
}

function searchFiles(searchQuery) {
  return {
    type: _ActionTypes2.SET_PANEL,
    activePanel: _Constants2.Panels.SEARCH,
    selectedFolder: null,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      usageTrackerJsName: 'fileManagerExploreFiles',
      action: 'started-search'
    }),
    searchQuery: searchQuery
  };
}

function goBack() {
  return {
    type: _ActionTypes2.BACK,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      usageTrackerJsName: 'fileManagerExploreFiles',
      action: 'back'
    })
  };
}

function setSearchQuery(searchQuery) {
  return {
    type: _ActionTypes2.SEARCH,
    searchQuery: searchQuery
  };
}

function selectFile(selectedFile) {
  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: _ActionTypes2.SELECT_FILE,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      usageTrackerJsName: 'fileManagerSelectOrDeselectExploreFiles',
      action: 'select-file',
      meta: meta
    }),
    selectedFile: selectedFile
  };
}

function deselectFile() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: _ActionTypes2.SELECT_FILE,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: 'Explore Files',
      usageTrackerJsName: 'fileManagerSelectOrDeselectExploreFiles',
      action: 'deselect-file',
      meta: meta
    }),
    selectedFile: null
  };
}

function maybeFetchFolders() {
  return function (dispatch, getState) {
    var state = getState();
    var folders = state.folders;

    if (folders.get('status') !== _Constants.RequestStatus.UNINITIALIZED) {
      return null;
    }

    return dispatch((0, _Folders.fetchFolders)()).done();
  };
}

function trackInteraction(name, action) {
  var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: _ActionTypes2.TRACK_INTERACTION,
    meta: (0, _defineProperty2.default)({}, _Constants.TRACK_EVENT, {
      name: name,
      usageTrackerJsName: (0, _utils.getUsageTrackerJsEventName)(name),
      action: action,
      meta: meta
    })
  };
}

function updateDetailHeight(file, height) {
  return {
    type: _ActionTypes2.UPDATE_DETAIL_HEIGHT,
    file: file,
    height: height
  };
}